export type Option = {
  label: string;
  value: string;
};

export type FormData = {
  issueType: Option;
  noOfIssues: number;
  notes: string;
};

export enum ISSUE_TYPE {
  MultipleStories = 'MultipleStories',
  MultipleEpics = 'MultipleEpics',
  EpicsAndStories = 'EpicsAndStories',
  SingleStory = 'SingleStory',
  SingleEpic = 'SingleEpic',
  SingleEpicMultiStories = 'SingleEpicMultiStories',
  EpicsAndTasks = 'EpicsAndTasks',
  SingleEpicMultiTasks = 'SingleEpicMultiTasks',
  MultipleTasks = 'MultipleTasks',
  SingleTask = 'SingleTask',
  StoriesAndTasks = 'StoriesAndTasks',
  SingleStoryMultiTasks = 'SingleStoryMultiTasks'
}
